<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-100vh">
      <div class="col-md-8">
        <div class="card ps-2 text-white main-color mb-1">
          <div class="card-body h2">
            {{this.config.projectName}}
          </div>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <h1>Login</h1>
              <div class="input-group mb-3 mt-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <b-icon icon="person-fill"></b-icon>
                  </span>
                </div>
                <input class="form-control" type="text" placeholder="Username">
              </div>
              <div class="input-group mb-4">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <b-icon icon="lock"></b-icon>
                  </span>
                </div>
                <input class="form-control" type="password" placeholder="Password">
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <BButton block variant="primary" @click.stop.prevent="login()">ログイン</BButton>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <button class="btn btn-link px-0" type="button">パスワードを忘れた方はこちら</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card text-white main-color py-5 d-md-down-none w-44">
            <div class="card-body text-center">
              <div>
                <h2>Sign up</h2>
                <p>アカウントが無い方は作成してください。</p>
                <BButton variant="outline-light" class="btn-lg mt-3" @click="signup">アカウント作成</BButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TraderLogin',
  data () {
    return {}
  },
  methods: {
    login () {
      this.$router.push('/trader/produce_proposition_list')
    },
    signup () {
      this.$router.push('/trader/signup')
    }
  }
}
</script>
